// extracted by mini-css-extract-plugin
export default {"imageWrapper":"gJ-z","videoWrapper":"hJ-z","twoColumnImage":"iJ-z","imageCarouselBtn":"jJ-z","carouselNextBtn":"kJ-z","carouselPrevBtn":"lJ-z"};